import { makeAutoObservable } from "mobx"
import { getStockDetailData } from "../../../modules/quote/web"
import { getPageType, PageType } from "../../shared/pagetype"
import { ChartType } from "../../shared/utils"

class Store {
  constructor() {
    if (getPageType() == PageType.期权) {
      makeAutoObservable(this)
      this.init()
    }
  }

  StockDetail: any = undefined

  chartType = ChartType.分时

  chart_mouse_move_data: any = null

  async init() {
    this.getData()

    setInterval(() => {
      this.getData()
    }, 30 * 1000)
  }

  async getData() {
    let data = await getStockDetailData(window.quotedata.quotecode, "f43,f44,f45,f46,f47,f48,f49,f50,f57,f58,f59,f60,f107,f130,f133,f152,f161,f162,f168,f169,f170,f177,f292")
    this.setStockDetail(data)
  }

  setStockDetail(StockDetail: any) {
    this.StockDetail = StockDetail
  }

  setChartType(chartType: ChartType) {
    this.chartType = chartType
  }

  setChartMouseMoveData(chart_mouse_move_data: any) {
    this.chart_mouse_move_data = chart_mouse_move_data
  }
}

export const store = new Store()
